import { render } from "./NoAccessPage.vue?vue&type=template&id=0c4a5ff0&ts=true"
import script from "./NoAccessPage.vue?vue&type=script&lang=ts"
export * from "./NoAccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__